import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { useBillingQueryContext } from '../../contexts';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import {
  EMAILS_SENT,
  SMS_SENT,
  PUSH_NOTIFICATIONS_SENT,
  SMS_BILLING_METRICS,
  WEB_PUSH_NOTIFICATIONS_SENT,
  IN_APP_NOTIFICATIONS_SENT,
  WHATSAPP_SENT,
} from '../../constants';
import {
  createColumns,
  createRows,
  isComprehensiveOrgMetric,
  isComprehensiveProjectMetric,
  queryByFn,
} from '../../utils';
import { MessagingPageActions } from './MessagingPageActions';
import { createRowCell } from './TableCell';

export const TEXT = {
  PAGE_TITLE: 'Messaging usage',
};

export const MessagingUsage = () => {
  const { ExpandedChannelMetrics, WhatsAppMessageChannelGA } = useSelector(selectFeatureFlags);
  const { projectIds, pickManyProjectMetrics, pickManyOrgMetrics, isLoading } =
    useBillingQueryContext();
  const { search } = useLocation();

  useEffect(() => {
    window.scrollTo();
  }, []);

  const metricNames = [
    EMAILS_SENT,
    SMS_SENT,
    PUSH_NOTIFICATIONS_SENT,
    ...(ExpandedChannelMetrics ? [WEB_PUSH_NOTIFICATIONS_SENT, IN_APP_NOTIFICATIONS_SENT] : []),
    ...(WhatsAppMessageChannelGA ? [WHATSAPP_SENT] : []),
    ...SMS_BILLING_METRICS,
  ];

  const orgMetrics = pickManyOrgMetrics(metricNames, isComprehensiveOrgMetric);
  const metricsByProjectId = projectIds.reduce(
    (acc, projectId) => ({
      [projectId]: pickManyProjectMetrics(projectId, metricNames, isComprehensiveProjectMetric),
      ...acc,
    }),
    {},
  );

  const rows = createRows(orgMetrics, metricsByProjectId);
  const columns = createColumns(metricsByProjectId);

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={{
        content: 'Usage and Billing',
        href: `/payments/info${search}`,
      }}
      pageTitle={TEXT.PAGE_TITLE}
      pageActions={<MessagingPageActions />}
      isLoading={isLoading}
      pluralResourceName="metrics"
      queryByFn={queryByFn}
      filterableColumns
      withHorizontalScroll
    />
  );
};
